import React from "react";
import { Link } from "react-router-dom";
import { FiAlertCircle, FiArrowLeft } from "react-icons/fi";
import "./SaaSUIToolkit.css";

export const SaaSNotFoundState = ({
  icon = <FiAlertCircle size={44} />,
  title = "Record Not Found",
  description = "The requested information could not be found or may have been removed.",
  backLink,
  backLabel = "Go Back",
  onBack,
}) => {
  return (
    <div className="container-fluid px-3 py-5 d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
      <div
        className="card border-0 shadow-sm rounded-4 p-4 p-md-5 text-center"
        style={{ maxWidth: "540px", width: "100%", background: "#ffffff" }}
      >
        <div
          className="d-inline-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle text-warning bg-warning bg-opacity-10"
          style={{ width: "80px", height: "80px" }}
        >
          {icon}
        </div>
        <h3 className="fw-bold text-dark mb-2" style={{ fontSize: "1.375rem" }}>
          {title}
        </h3>
        <p className="text-muted small mb-4" style={{ lineHeight: 1.6 }}>
          {description}
        </p>
        <div className="d-flex justify-content-center gap-2">
          {backLink && (
            <Link
              to={backLink}
              className="btn btn-primary btn-sm px-4 py-2 rounded-3 d-inline-flex align-items-center gap-2 shadow-sm fw-medium"
            >
              <FiArrowLeft size={15} />
              <span>{backLabel}</span>
            </Link>
          )}
          {!backLink && onBack && (
            <button
              type="button"
              onClick={onBack}
              className="btn btn-primary btn-sm px-4 py-2 rounded-3 d-inline-flex align-items-center gap-2 shadow-sm fw-medium"
            >
              <FiArrowLeft size={15} />
              <span>{backLabel}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SaaSNotFoundState;
